import { render, staticRenderFns } from "./Connections.vue?vue&type=template&id=24b12784"
import script from "./Connections.js?vue&type=script&lang=js&external"
export * from "./Connections.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports